<template>
  <div>
    <button
      type="button"
      class="btn btn-outline-dark border-2 btn-sm fw-semibold"
      :aria-expanded="isOpen"
      :aria-controls="id"
      @click="toggle"
    >
      <span class="bi bi-list-ul me-1" aria-hidden="true"></span>
      Contents
    </button>

    <div
      ref="offcanvasEl"
      class="offcanvas offcanvas-start"
      tabindex="-1"
      :id="id"
      :aria-labelledby="`${id}-label`"
    >
      <div class="offcanvas-header border-bottom">
        <h2 :id="`${id}-label`" class="h5 mb-0 fw-semibold">
          Workbook contents
        </h2>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close workbook contents"
        />
      </div>
      <div class="offcanvas-body overflow-y-auto">
        <nav :aria-labelledby="`${id}-label`">
          <ul class="list-unstyled m-0 d-flex flex-column gap-1">
            <li v-for="item in passages" :key="item.id">
              <button
                type="button"
                class="btn w-100 text-start py-2 px-2 rounded"
                :class="{
                  'fw-semibold bg-light': item.id === currentPassageId,
                  'text-muted opacity-50': !isPassageUnlocked(item.id)
                }"
                :disabled="!isPassageUnlocked(item.id)"
                :aria-current="
                  item.id === currentPassageId ? 'true' : undefined
                "
                @click="onSelect(item.id)"
              >
                {{ item.label }}
                <span
                  v-if="!isPassageUnlocked(item.id)"
                  class="visually-hidden"
                >
                  — Not yet reached
                </span>
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import { Offcanvas } from "bootstrap";

export default {
  name: "WorkbookTocOffcanvas",
  props: {
    id: {
      type: String,
      default: "workbookTocOffcanvas"
    },
    passages: {
      type: Array,
      default: () => []
    },
    currentPassageId: {
      type: String,
      default: ""
    },
    /** Passage ids the learner has already entered (plus current is always usable). */
    visitedPassageIds: {
      type: Array,
      default: () => []
    }
  },
  emits: ["select"],
  data() {
    return {
      offCanvas: null,
      isOpen: false
    };
  },
  methods: {
    isPassageUnlocked(passageId) {
      return (
        passageId === this.currentPassageId ||
        this.visitedPassageIds.includes(passageId)
      );
    },
    toggle() {
      this.offCanvas?.toggle();
    },
    show() {
      this.offCanvas?.show();
    },
    hide() {
      this.offCanvas?.hide();
    },
    onSelect(passageId) {
      if (!this.isPassageUnlocked(passageId)) return;
      this.$emit("select", { id: passageId });
    },
    onOffcanvasShown() {
      this.isOpen = true;
    },
    onOffcanvasHidden() {
      this.isOpen = false;
    }
  },
  mounted() {
    const el = this.$refs.offcanvasEl;
    this.offCanvas = new Offcanvas(el);
    el.addEventListener("shown.bs.offcanvas", this.onOffcanvasShown);
    el.addEventListener("hidden.bs.offcanvas", this.onOffcanvasHidden);
  },
  beforeUnmount() {
    const el = this.$refs.offcanvasEl;
    if (el) {
      el.removeEventListener("shown.bs.offcanvas", this.onOffcanvasShown);
      el.removeEventListener("hidden.bs.offcanvas", this.onOffcanvasHidden);
    }
    this.offCanvas?.dispose();
  }
};
</script>
